import { ThreeDots } from 'react-loader-spinner';

const DotLoading = ({ width, height }) => {
  return <ThreeDots
    height={height ? height : "17"}
    width={width ? width : "45"}
    radius="10"
    color="#753cbe"
    ariaLabel="three-dots-loading"
    wrapperStyle={{}}
    wrapperClassName=""
    visible={true}
  />;

};

export default DotLoading;
